import api from './api';
import { AppResponse } from '../models/common/app-response';
import { DispatcherHomeStatisticsDto } from '../models/home/dispatcherHomeStatisticsDto';
import { MedicHomeStatisticsDto } from '../models/home/medicHomeStatisticsDto';
import { DateUtils } from '../helpers/dateUtils';

class HomeService {
    baseUrl: string = "/api/v1/home";

    getDispatcherStatistics() {
        const timeZoneOffset = DateUtils.getTimeZoneShiftHours();
        return api.get<AppResponse<DispatcherHomeStatisticsDto>>(`${this.baseUrl}/dispatcher-statistics`, {
            params: { timeZoneOffset }
        });
    }

    getMedicStatistics() {
        const timeZoneOffset = DateUtils.getTimeZoneShiftHours();
        return api.get<AppResponse<MedicHomeStatisticsDto>>(`${this.baseUrl}/medic-statistics`, {
            params: { timeZoneOffset }
        });
    }

    downloadDriverImportTemplate() {
        return api.get(`${this.baseUrl}/driver-import-template`, {
            responseType: 'blob'
        });
    }
}

export const homeService = new HomeService();

